import React from "react";
import "./style.scss";
function CheckboxInput({
  name,
  linksdata,
  type,
  alert,
  setInputs,
  addditionaldata,
  defaultChecked,
}) {
  return (
    <div>
      <div className="custom-div-termsNcond">
        <input
          id={name}
          name={name}
          type={type}
          defaultChecked={defaultChecked ? defaultChecked : false}
          onChange={setInputs}
          className={`custom-input-termsNcond ${alert ? "input-error" : ""}`}
        />
        <label htmlFor={name} className="custom-label-termsNcond">
          {linksdata.beforeText}
          <a href={linksdata.linkUrl} target="_blank" rel="noreferrer">
            {linksdata.linkText}
          </a>
        </label>
      </div>
      {addditionaldata.map((s) => (
        <div className="additional-label-termsNcond" key={s[0]}>
          {s[0]}
          <a href={s[2]} target="_blank" rel="noreferrer">
            {s[1]}
          </a>
        </div>
      ))}

      <div className="input-error-label">{alert}</div>
    </div>
  );
}
export default CheckboxInput;
